/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import styled from '@emotion/styled'

import { Button, Icon, Message, MessageContent, MessageHeader, MessageItem, MessageList } from 'semantic-ui-react'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { UltyModalWrapperContext } from '../../../../Shared/UltyModalWrapper/UltyModalWrapperContext';
import { getOrderItemPendingCustomerAction, getOrderItemReplacementRelatedToPendingCustomerAction, getOrderItemWithPickingAction } from '../../_helpers/orderItemFilter';

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 1rem;
    margin-bottom: 2rem;
    margin-top: 1.5rem;
`

const MessageIcon = styled(Icon)`
    i.warning.circle.icon {
        font-size: 2em;
    }
`

const StyledMessage = styled(Message)`
    &.ui.yellow.icon.message {
        
        & > div.content > div.header {
            font-size: 1em;
        }
    }

    &.ui.orange.icon.message {
      
        
        & > div.content > div.header {
            font-size: 1em;
        }
    }
`

const OrderPickupRemovedItemRemainder = ({orderItems, onSubmit}) => {
    const [t] = useTranslation()
    const {handleUltyModalWrapper} = useContext(UltyModalWrapperContext);
    
    const pendingItems = getOrderItemReplacementRelatedToPendingCustomerAction(orderItems);
    const hasPendingItems = pendingItems.length > 0;
    
    const itemToRemove = getOrderItemWithPickingAction(orderItems);
    const hasItemToRemove = itemToRemove.length > 0;

    const [state,setState] = useState(hasPendingItems ? 'pending' : 'remove');

    return (
      <>
          <Container>
              <StyledMessage
                color={state === 'pending' ? 'yellow' : 'orange'}
                icon
              >
                  <MessageContent>
                     
                      {hasPendingItems && state === 'pending' && (<>
                            <MessageHeader>
                                <span  css={css`white-space: pre-wrap;`}>
                                {t('order.pickup.order_pickup_removed_reminder.some_products_are_pending_customer',{count:pendingItems.length})}
                                </span>
                        </MessageHeader>
                        <MessageList>
                            {pendingItems.map(orderItem => <MessageItem key={orderItem.id}>{orderItem.item?.object?.name}</MessageItem>)}
                        </MessageList>
                      </>
                      )}
                      {hasItemToRemove && state === 'remove' && (<>
                        <MessageHeader>
                          {t('order.remove_order_items_reminder.message',{count:itemToRemove.length})}
                        </MessageHeader>
                          <MessageList>
                            {itemToRemove.map(orderItem => <MessageItem key={orderItem.id}>{orderItem.item?.object?.name}</MessageItem>)}
                        </MessageList>
                        </>
                      )}
                  </MessageContent>
              </StyledMessage>
          </Container>

          <div style={{textAlign: 'center'}}>

                             {state === 'pending' && hasPendingItems && (
                                 <div
                                     css={css`
                                         display: flex;
                                         flex-direction: row;
                                         justify-content: center;
                                         align-items: stretch;
                                         gap: 0.5rem;
                                         @media (max-width: 767px) {
                                             flex-direction: column;
                                             gap: 0.25rem;
                                             & .ui.button, & .or {
                                                 width: 100%;
                                             }
                                         }
                                     `}
                                 >
                                     <Button
                                         fluid
                                         size='large'
                                         color="grey"
                                         onClick={() => {
                                             handleUltyModalWrapper(false, null)
                                         }}
                                     >
                                         {t('order.pickup.order_pickup_removed_reminder.wait_a_bit_more')}
                                     </Button>
                                     <Button.Or text={"ou"}/>
                                     <Button
                                         fluid
                                         size='large'
                                         color="teal"
                                         onClick={() => {
                                             setState('remove')
                                         }}
                                     >
                                         {t('order.mark_as_ready')}
                                     </Button>
                                 </div>
                             )}
               {(state === 'remove') && hasItemToRemove && (
                <Button
                fluid
                size='huge'
                color="teal"
                onClick={() => {
                    onSubmit()
                    handleUltyModalWrapper(false, null)
                }}
              >
                  {t('global.validate')}
              </Button>
               )}
              
          </div>
      </>
    )
}


OrderPickupRemovedItemRemainder.propTypes = {
    orderItems: PropTypes.arrayOf(
      PropTypes.shape({
          item: PropTypes.shape({
              object: PropTypes.shape({
                  name: PropTypes.string,
              }),
          }),
      }),
    ).isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default OrderPickupRemovedItemRemainder
